import React from 'react';
import './index.css';
import {Menu, Message, Select, Table, Row, Col, FormControl, Modal, Button} from 'tinper-bee';
import * as util from '../../utils';
import dragColumn from "tinper-bee/lib/dragColumn.js";
const DragColumnTable = dragColumn(Table);

class OidCheck extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            list: [],
            env: 'daily',
            type: 'ucf',
        };
    }


    componentDidMount() {
        this.getList()
    }

    menuClick(e) {
        this.setState({
            selectedKeys: [e.key]
        })
    }
    async getList(){
        const {cdn, env, tns, project, clean, type} = this.state;
        const obj: any = {};
        if(env && env !== 'all') {
            obj.env = env
        }
        if(tns && tns !== 'all') {
            obj.tns = tns
        }
        if(clean && clean !== 'all') {
            obj.clean = clean
        }
        if(cdn && cdn !== 'all') {
            obj.cdn = cdn
        }
        if(type && type !== 'all') {
            obj.type = type
        }
        if(project && project !== '') {
            obj.project = project
        }
        const res = await util.get('/npm/tns/list', obj);
        this.setState({list: res.body})
    }
    async scanning(data) {
        const {env, project, type} = data;
        const select = await util.get('/npm/tns/task', {env, project});
        if(select && select.body.status === 'ongoing') {
            Message.create({content: `已存在${project}的${env}环境下的扫描任务，请勿重复扫描`, color: 'warning'});
        } else if(!select.body.status || select.body.status === 'end') {
            const res = await util.post('/npm/tns/scanning', {env, project, type});
            Message.create({content: "扫描任务已开启，请稍后再进行查询！", color: 'success'});
        }
    }
    editRemarks(record) {
        this.setState({editData: record, remarks: '', show: true})
    }
    async onConfirm() {
        const {editData, remarks} = this.state
        const {env, project, type} = editData;
        const res = await util.post('/npm/tns/remarks', {env, project, remarks});
        if(res.body) {
            Message.create({content: "修改成功！", color: 'success'});
            this.setState({show: false})
            this.getList();
        } else {
            Message.create({content: "修改失败！", color: 'success'});
        }
    }
    onCancel() {
        this.setState({show: false})
    }
    render() {
        const { list } = this.state;
        const that = this;
        const column = [
            {
                title: "序号",
                dataIndex: "index",
                key: "index",
                width: '5%',
                render(text, record, index){return index + 1}
            },
            {
                title: "项目编码", dataIndex: "project", key: "project",width: '10%',
            },
            {
                title: "所属类型", dataIndex: "type", key: "type",width: '10%',
            },
            {
                title: "环境", dataIndex: "env", key: "env",width: '10%',
            },
            {
                title: "是否接入TNS", dataIndex: "tns", key: "tns",width: '5%'
            },
            {
                title: "是否开启CDN替换", dataIndex: "cdn", key: "cdn",width: '5%'
            },
            {
                title: "是否开启实例清理", dataIndex: "clean", key: "clean",width: '5%',
            },
            {
                title: "SDK-TAG", dataIndex: "sdk_provide", key: "sdk_provide",width: '10%',
            },
            {
                title: "依赖的SDK", dataIndex: "sdk_depend", key: "sdk_depend",width: '10%',
            },
            {
                title: "上次扫描时间", dataIndex: "scan_time", key: "scan_time",width: '10%',
            },
            {
                title: "备注", dataIndex: "remarks", key: "remarks",width: '10%',
            },
            {
                title: "操作", dataIndex: "make", key: "make",render(text, record, index): any {
                    return <div>
                        <a style={{cursor: 'pointer', marginRight: 10}} onClick={() => that.scanning(record)}>重新检查</a>
                        <a style={{cursor: 'pointer'}} onClick={() => that.editRemarks(record)}>修改备注</a>
                    </div>
                },
            },
        ];
        return (
            <div className='tns-content'>
                <Modal dialogClassName='org-select-modal' show={this.state.show} className="demo3-modal">
                    <Modal.Header>
                        <Modal.Title>修改备注</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <span>备注：</span>
                        <span>
                            <FormControl
                                style={{width: 300}}
                                value={this.state.remarks}
                                onChange={(e) => this.setState({remarks: e},() => this.getList())}
                        /></span>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button style={{marginRight: 20}} onClick={() => this.onCancel()}>取消</Button>
                        <Button onClick={() => this.onConfirm()}>确定</Button>
                    </Modal.Footer>
                </Modal>
                <Row style={{marginBottom: 20}}>
                    <Col md={2} xs={2} sm={2}>
                        <div>
                            <span className={'title'}>项目所属类型</span>
                            <Select
                                value={this.state.type}
                                style={{width: 200, marginRight: 6}}
                                onChange={(e) => this.setState({type: e},() => this.getList())}
                            >
                                <Select.Option value={'all'}>全部</Select.Option>
                                <Select.Option value={'ucf'}>UCF</Select.Option>
                                <Select.Option value={'mdf'}>MDF</Select.Option>
                            </Select>
                        </div>
                    </Col>
                    {/*<Col md={2} xs={2} sm={2}>*/}
                    {/*    <div>*/}
                    {/*        <span className={'title'}>项目</span>*/}
                    {/*        <FormControl*/}
                    {/*            value={this.state.project}*/}
                    {/*            style={{width: 200, marginRight: 6}}*/}
                    {/*            onChange={(e) => this.setState({project: e.target.value},() => this.getList())}*/}
                    {/*        />*/}
                    {/*    </div>*/}
                    {/*</Col>*/}
                    <Col md={2} xs={2} sm={2}>
                        <div>
                            <span className={'title'}>环境</span>
                            <Select
                                value={this.state.env}
                                style={{width: 200, marginRight: 6}}
                                onChange={(e) => this.setState({env: e},() => this.getList())}
                            >
                                <Select.Option value={'all'}>全部</Select.Option>
                                <Select.Option value={'test'}>测试环境</Select.Option>
                                <Select.Option value={'daily'}>日常环境</Select.Option>
                                <Select.Option value={'pre'}>预发环境</Select.Option>
                                <Select.Option value={'online'}>生产环境</Select.Option>
                                <Select.Option value={'stage'}>灰度环境</Select.Option>
                                <Select.Option value={'stage-dc-core1'}>核心1-灰度环境</Select.Option>
                            </Select>
                        </div>
                    </Col>
                    <Col md={2} xs={2} sm={2}>
                        <div>
                            <span className={'title'}>TNS接入</span>
                            <Select
                                value={this.state.tns}
                                style={{width: 200, marginRight: 6}}
                                onChange={(e) => this.setState({tns: e}, () => this.getList())}
                            >
                                <Select.Option value={'all'}>全部</Select.Option>
                                <Select.Option value={'true'}>已接入</Select.Option>
                                <Select.Option value={'false'}>未接入</Select.Option>
                            </Select>
                        </div>

                    </Col>

                    <Col md={2} xs={2} sm={2}>
                        <div>
                            <span className={'title'}>CDN替换</span>
                            <Select
                                value={this.state.cdn}
                                style={{width: 200, marginRight: 6}}
                                onChange={(e) => this.setState({cdn: e}, () => this.getList())}
                            >
                                <Select.Option value={'all'}>全部</Select.Option>
                                <Select.Option value={'true'}>已开启</Select.Option>
                                <Select.Option value={'false'}>未开启</Select.Option>
                            </Select>
                        </div>

                    </Col>

                    <Col md={2} xs={2} sm={2}>
                        <div>
                            <span className={'title'}>清理实例</span>
                            <Select
                                value={this.state.clean}
                                style={{width: 200, marginRight: 6}}
                                onChange={(e) => this.setState({clean: e}, () => this.getList())}
                            >
                                <Select.Option value={'all'}>全部</Select.Option>
                                <Select.Option value={'true'}>已开启</Select.Option>
                                <Select.Option value={'false'}>未开启</Select.Option>
                            </Select>
                        </div>
                    </Col>
                </Row>
                <div>
                    查询数量：{list.length}
                </div>
                <DragColumnTable
                    dragborder
                    columns={column}
                    data={list}
                />
            </div>
        )
    }
}
export default OidCheck;
